import { queryOptions } from "@tanstack/react-query";
import { ApiError, apiGet } from "../lib/api";

export type MeResponse = {
  id: string;
  email: string;
  name: string | null;
  image: string | null;
};

export const meQueryOptions = queryOptions<MeResponse | null>({
  queryKey: ["me"],
  queryFn: async () => {
    try {
      return await apiGet<MeResponse>("/api/me");
    } catch (err) {
      if (err instanceof ApiError && err.status === 401) return null;
      throw err;
    }
  },
  staleTime: 60_000,
});
